export default __webpack_public_path__ + "70118959919f0f33586efa1977e1787b.png";